import React from "react";
import { Row } from "react-bootstrap";
import { FaHeadset, FaUserTie, FaHandshake, FaStar } from "react-icons/fa";

const Ecosystem = () => {
  return (
    <section className="vendor-categories-section py-5 bg-white">
      <div className="container py-5">
        {/* Heading */}
        <div className="row justify-content-center">
          <div className="col-lg-8 text-center mb-5">
            <span className="works-subtitle">Overview</span>
            <h2 className="display-5 fw-bold mb-4">
              Complete Ecosystem Overview
            </h2>
            <p className="lead">
              One smart ecosystem that powers smoother management, stronger
              communication, and safer communities.
            </p>
          </div>
        </div>

        {/* Categories */}
        <Row className="g-4">
          {[
            {
              icon: <FaHeadset />,
              title: "Customer Services",
              subtitle: "Instant service booking",
            },
            {
              icon: <FaUserTie />,
              title: "Employee Register ",
              subtitle: "Onboarding platform for Workers & Riders",
            },
            {
              icon: <FaHandshake />,
              title: "Product Collab",
              subtitle: "Integration of Material & Tool suppliers",
            },
            {
              icon: <FaStar />,
              title: "Rating & Contact ",
              // color: "info",
              subtitle: "Comprehensive trust- building system",
            },
          ].map((item, index) => (
            <div key={index} className="col-md-6 col-lg-3">
              <div className="card h-100 text-center hover-card">
                <div className="card-body">
                  <div
                    className={`icon-wrapper text-white rounded-circle mx-auto mb-3 d-flex align-items-center justify-content-center`}
                  >
                    {item.icon}
                  </div>
                  <h5>{item.title}</h5>
                  <span>{item.subtitle}</span>
                </div>
              </div>
            </div>
          ))}
        </Row>
      </div>
    </section>
  );
};

export default Ecosystem;
